import { type ExpApiGetInviteesResponse, type ExusGetInviteesResponse } from '../types';

const EXUS_GET_INVITEES_URL = '/gateway/api/external-users/invite-recommendations/get-invitees';

export const getInvitees = async (
	product: string,
	jiraCloudId: string,
	confluenceCloudId: string,
	spaceKey?: string,
): Promise<ExusGetInviteesResponse> => {
	const spaceKeyParam = spaceKey ? `&spaceKey=${encodeURIComponent(spaceKey)}` : '';

	const response = await fetch(
		`${EXUS_GET_INVITEES_URL}?product=${encodeURIComponent(
			product,
		)}&jiraCloudId=${encodeURIComponent(jiraCloudId)}&confluenceCloudId=${encodeURIComponent(
			confluenceCloudId,
		)}${spaceKeyParam}`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		},
	);
	return response.json();
};

export const getInviteesFromExpApi = async (
	jiraCloudId: string,
	confluenceCloudId: string,
	pageId: string,
	userId: string,
	accountIds: string[],
): Promise<ExpApiGetInviteesResponse> => {
	const response = await fetch(
		'/gateway/api/growth/invite-on-link-insert-confluence/get-invitees',
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ jiraCloudId, confluenceCloudId, pageId, userId, accountIds }),
		},
	);
	return await response.json();
};
